export const getRedirectUrl = (path: string): string =>
  `${window.location.origin}${path}`
